// وارداتِ زبانِ «en» — به‌صورتِ جدا از موتورِ i18n، تا فقط وقتی لازم شد
// بارگذاری شود (نگاه کن به لودرِ داینامیک در ../i18n.ts).
const dict: Record<string, string> = {
  appName: '{brand}',
  home: 'Home', discover: 'Discover', friends: 'Friends', profile: 'Profile',
  back: '‹ Back', create: 'Create', send: 'Send',
  accept: 'Accept ✓', decline: 'Decline', doneCheck: 'Done ✓',
  error: 'Error', errorRetry: 'Error — try again',

  notifsRead: 'Notifications read',
  notifications: 'Notifications',
  notifSettings: 'Notifications',
  notifHistory: 'All notifications',
  notifCatFriendRequest: 'Friend requests',
  notifCatFriendRequestHint: 'Someone wants to be your friend, or accepted your request',
  notifCatSignal: 'Plans',
  notifCatSignalHint: 'A friend makes a plan you might want to join',
  notifCatEvent: 'Plan updates',
  notifCatEventHint: 'People answer your plan, it gets confirmed, or a reminder fires',
  notifModePush: 'Notification',
  notifModePushHint: 'Your phone alerts you even when {brand} is closed',
  notifModeInApp: 'Only inside the app',
  notifModeInAppHint: "You'll see it next time you open {brand} — no interruption",
  notifModeOff: 'Nothing',
  notifModeOffHint: "Don't tell me about these at all",
  followTags: "Followed tags",
  followTagsSub: "New events with these tags in your city will reach you",
  notifCatTagFollow: "Followed tags",
  notifCatTagFollowHint: "A new event with a tag you follow shows up in your city",
  notifModeEmail: "Email",
  notifModeEmailHint: "One email per event; between 9 pm and 9 am it waits until morning",
  followTagsNoPush: "Notifications for {brand} are off on this device, so these can't reach your phone — allow them, or pick email",
  followTagAction: "Follow",
  updateTitle: 'App updates',
  updateAuto: 'Update automatically',
  updateAutoHint: 'New versions install themselves — you never have to think about it',
  updateManual: 'Just tell me',
  updateManualHint: "You'll get a notice and decide when to update",
  updateNativeNote: 'Some updates change the app itself and cannot install automatically — Android always asks first. For those we send you a link.',
  updateReadyTitle: 'A new version is ready',
  updateReadyBody: 'Tap to restart and use it',
  updateApply: 'Update now',
  updateApkTitle: 'Version {v} is out',
  updateApkBody: 'This one needs a fresh install',
  updateApkGet: 'Download it',
  notifBadgeCaveat: 'The number on the app icon depends on your launcher. Samsung and Pixel show it; some others ignore it.',
  notifRecent: 'Already handled',
  notifTodo: 'Waiting for you',
  noNotifications: 'Nothing here yet',
  notifFriendRequest: '{name} wants to be your friend',
  notifFriendRequestBody: 'Tap to accept or decline',
  notifFriendAccepted: '{name} accepted your request',
  notifFriendAcceptedBody: "You're friends now",
  incoming: 'From your friends', noIncoming: 'No plans yet — add a few friends first',
  mySignals: 'My plans', noMine: 'You haven\'t made a plan yet — start with the button below',
  suggestions: 'Suggestions',
  suggestionText: 'It\'s been a while since you planned with some friends — start with a simple plan ', suggestionCoffeeBtn:'A coffee this week', suggestionCoffeeTitle: 'A coffee this week?',
  postIdea: 'Make a plan',
  newSignal: '+ New plan',

  filter: 'Filter', onlyFree: 'Free only', eventsCount: 'Events ({n})',
  tabList: 'List', tabMap: 'Map',
  tabEvents: 'Events',
  tabPlaces: 'Places',
  viewMode: 'View',
  viewCompact: 'Compact view',
  viewMagazine: 'Magazine view',
  viewPhoto: 'Photo view',
  viewMap: 'Map view',
  moreOptions: 'Options',
  search: 'Search',
  searchAllHint: 'Search anything — name, address, description',
  searchShowing: 'Search “{q}” — {n} found', searchShowAll: 'Show all',
  sortBy: 'Sort',
  sortNextTime: 'Happening next',
  sortAdded: 'Recently added',
  sortDistance: 'Closest to me',
  sortPopular: 'Most popular',
  sortPrice: 'Price — free first',
  sortTitle: 'Title — A to Z',
  sortTitleDesc: 'Title — Z to A',
  sortReview: 'Review priority',
  sortReviewEmpty: 'No review priorities came in — the list is in its usual order.',
  sortFlagged: 'Flagged first',
  sortFlaggedEmpty: 'Nothing is flagged — the list is in its usual order.',
  sortDistanceDenied: 'Sorting by distance needs your location. Turn it on for {brand} in your settings.',
  sortDistanceFailed: "Couldn't find where you are — the list is in its usual order.",
  filterClose: 'Close',
  groups: "Groups",
  membersCount: "{n} members",
  reachApp: "in app",
  reachSms: "SMS",
  reachEmail: "email",
  reachNone: "no way to reach",
  groupOfSomeoneElse: "someone else’s group",
  contactsLoadedCount: "{n} contacts loaded",
  edit: "edit",
  pickManyHint: "Tap names to select, then add them all",
  addSelectedCount: "Add {n}",
  addedFriendsCount: "{n} added to your friends",
  filterCount: 'Filter ({n})',
  filterWhat: 'Show me',
  filterAll: 'Everything', filterEventsOnly: 'Only events', filterBusinessesOnly: 'Only places',
  filterKind: 'Type',
  filterWhen: 'When',
  filterDay: 'Day',
  filterTime: 'Time of day',
  filterDate: 'Date',
  filterPrice: 'Price',
  filterCategory: 'Tag',
  /* ردیفِ دسته‌های کشف: هشت‌تای اول، و بقیه پشتِ همین دکمه. */
  catMore: 'More', catLess: 'Fewer',
  filterAdmin: 'Admin',
  filterCombined: 'Combined',
  whenToday: 'Today',
  whenTomorrow: 'Tomorrow',
  whenWeekend: 'This weekend',
  whenDate: 'Pick a date',
  partMorning: 'Morning',
  partAfternoon: 'Afternoon',
  partEvening: 'Evening',
  filterExtras: 'Narrow it down',
  onlyDiscount: 'With a deal',
  filterClear: 'Clear', filterApply: 'Show results',
  businessesCount: 'Places ({n})',
  noBusinesses: 'Nothing with these filters — change the filter',
  hasDiscount: 'Has a deal',
  openLink: 'Reference',
  favoriteAdd: 'Save',
  favoriteRemove: 'Saved',
  placeSource: 'Official page',
  mapNoPins: 'Nothing to show on the map with these filters',
  eventOccurrences: 'Dates and places',
  eventOccurrencesSameLink: 'Same link for all of these',
  adminCombineBoth: 'Keep both',
  adminCombineBothHint: 'Each source becomes its own date and place, with its own link',
  mapTooMany: 'Showing {n} of {total} pins — zoom in with the filters to see the rest',
  mapMeHere: 'You are here',
  directions: 'Directions',
  directionsFailed: "No maps app opened — there may not be one installed",
  suggestTitle: 'Suggest a place or event',
  suggestWhat: 'What are you suggesting?',
  suggestBusiness: 'A place',
  suggestBusinessHint: 'Cafe, restaurant, gym — somewhere that is always there',
  suggestEvent: 'An event',
  suggestEventHint: 'Something happening on a specific date',
  suggestDetails: 'Details',
  suggestNameBiz: 'Name of the place', suggestNameBizPh: 'e.g. Bridgehead Coffee',
  suggestNameEvent: 'Name of the event', suggestNameEventPh: 'e.g. Winterlude',
  suggestUrl: 'Link to their official page (required)',
  suggestUrlWhy: 'Without a source we cannot check it, so this one is required.',
  suggestUrlInvalid: 'That does not look like a web address',
  suggestUrlRequired: 'A valid link is required',
  suggestDescription: 'Description',
  help: 'Help',
  pickOnMap: 'Pick on the map',
  mapPickHint: 'Tap the map where it is. You can drag the pin afterwards.',
  mapPicked: 'Point set',
  mapClear: 'Remove the point',
  mapPickFailed: 'The map did not load — the address on its own is fine',
  whereHint: 'A name, an address, or both — whatever helps someone find it.',
  suggestDescriptionPh: 'A line or two',
  suggestAddress: 'Address (optional)', suggestAddressPh: 'e.g. 366 Bank St',
  hasDiscountQ: 'Offers a deal',
  noDiscount: 'No deal', notFree: 'Paid', pickTags: 'Choose tags',
  where: 'Where?',
  signalNoteWhat: 'what the plan is about',
  signalNoteHow: 'how to get there, or where to park',
  signalNoteBring: 'what to bring',
  signalNoteCost: 'any likely costs',
  pickPeople: 'Choose friends and groups',
  inviteOutside: 'Invite someone who is not on the app',
  discountNotePh: 'e.g. 10% off for students',
  suggestSend: 'Send suggestion',
  suggestThanks: 'Thanks! We will take a look',
  suggestReviewNote: 'Your suggestion is not public yet — it shows up for everyone once it is approved.',
  // ── رخدادِ خودِ کاربر (مایگریشن 0077) ──
  suggestEndRequired: 'An end date is required — your event stays pinned at the top of your list until then.',
  suggestOrganizer: 'I am the organiser',
  suggestOrganizerHint: 'You run this event, so your later edits go live straight away',
  suggestAnnouncerHint: 'Someone else runs it — later edits are reviewed first',
  buyTicket: 'Buy a ticket',
  suggestTicketUrl: 'Ticket link (optional)',
  suggestTicketUrlHint: 'A direct link to buying a ticket, if there is one',
  suggestImage: 'Photo',
  suggestImageWhy: 'Strongly recommended: an event with a photo is opened several times more often.',
  suggestImagePick: 'Choose a photo',
  suggestImageChange: 'Change photo',
  suggestImageRemove: 'Remove photo',
  suggestImageFailed: 'The photo did not upload — try again',
  suggestImageDenied: 'No access to your photos — you can allow it in settings',
  suggestDescribeWhat: 'what it is about',
  suggestDescribeAges: 'age range',
  suggestDescribeType: 'type of event (concert, workshop, market…)',
  suggestDescribeHost: 'who is running it',
  suggestDescribeParking: 'where to park',
  suggestDescribeAccess: 'how to get in — door, floor, accessibility',
  suggestDescribeBring: 'what to bring',
  myEvents: 'Your events',
  myEventPending: 'Waiting for approval',
  myEventLive: 'Approved — everyone can see it',
  myEventEditPending: 'Live, and your edit is waiting for approval',
  myEventRejected: 'Not approved',
  myEventShortApproved: 'Approved',
  myEventShortWaiting: 'Waiting',
  myEventShortRejected: 'Rejected',
  myEventPinNote: 'Only you see this. It stays here until {date}.',
  myEventStats: '{seen} saw the card · {opened} opened it ({openRate}) · {clicked} clicked the link ({clickRate})',
  myEventStatsEmpty: 'No one has seen it yet',
  myEventEdit: 'Edit',
  myEventSaved: 'Saved — it is live right away',
  myEventSavedForReview: 'Sent — an admin will review it before it goes live',
  myEventDelete: 'Delete this event',
  myEventDeleteConfirm: 'It disappears from your list and from everyone else\'s. You cannot undo this yourself.',
  myEventDeleted: 'Deleted',
  myEventAddPhoto: 'Add a photo',
  editEvent: 'Edit event',
  editEventSub: 'Your changes need approval before everyone sees them.',
  editEventNote: 'Note about this change (optional)',
  editEventNotePh: 'What did you change and why?',
  editEventSend: 'Submit for review',
  editEventThanks: 'Sent — an admin will review it.',
  venueName: 'Venue name',
  venueNamePh: "e.g. Lansdowne Park",
  eventVersions: 'versions',
  versionsTitle: 'Versions',
  versionPending: 'Pending review',
  versionPublished: 'Live',
  versionRejected: 'Rejected',
  versionSuperseded: 'Replaced',
  versionExpired: 'Expired',
  versionApprove: 'Approve',
  versionReject: 'Reject',
  versionDeleteLive: 'Remove event',
  versionReasonTitle: 'Reason (required)',
  versionReasonPh: 'Why are you rejecting/removing this?',
  versionReasonRequired: 'A reason is required',
  versionEditedBy: 'Edited by {name}',
  versionReviewedBy: 'Reviewed by {name}',
  priceNoteLabel: 'Price note',
  priceNotePh: 'e.g. $15 at the door',
  eventEndsAt: 'Ends at (optional)',
  eventWeekdaysLabel: 'Repeats on (optional)',
  addTime: 'Add a time',
  noTime: 'No time',
  pickDayHint: 'Tap a day. Tap a second, later day to make it a range. A time is optional.',
  signalDateOffEvent: 'This date isn’t one of this event’s dates — you can still send it.',
  eventMonthdaysLabel: 'Days of the month (optional)',
  eventMonthWeeksLabel: 'Which week of the month (optional)',
  eventMonthWeeksHint: 'Combines with the days above: “first Friday of each month”.',
  eventDatesLabel: 'Separate dates (optional)',
  addDate: '+ Add a date',
  removeDate: 'Remove',
  eventEndRequired: 'An event needs an end time too',
  monthlyDays: 'Day {days} of each month',
  monthlyWeek: '{nth} {day} of each month',
  weekdayRange: '{from} to {to}',
  ordFirst: 'first', ordSecond: 'second', ordThird: 'third',
  ordFourth: 'fourth', ordFifth: 'fifth', ordLast: 'last',
  adminPendingTitle: 'Pending review',
  adminPendingEmpty: 'Nothing waiting for review',
  adminPendingCount: '{n} waiting for review',
  adminTools: 'Admin tools',
  adminToolsHint: 'Review queue, ids, merging and raw data',
  adminOpenItem: 'Open',
  adminFindPh: 'Numeric id',
  adminNotFound: 'No item with id {id}',
  adminIdCopied: 'Copied {id}',
  adminStatusMerged: 'Merged',
  adminFlaggedTitle: 'Flagged for review',
  adminFlaggedEmpty: 'Nothing is flagged',
  adminMergedEmpty: 'Nothing has been merged yet',
  adminDone: 'Done',
  adminDelete: 'Delete item',
  adminDeleteHint: 'It stops showing up, but nothing is erased — you can bring it back.',
  adminReasonPh: 'Reason (optional)',
  adminRestore: 'Bring back',
  adminFlagOn: 'Flag for review',
  adminFlagOff: 'Clear flag',
  adminFlagHint: 'Only you see this. The item stays visible to everyone else.',
  adminFlagNotePh: 'What looks wrong? (optional)',
  adminFlaggedBy: 'flagged by {name}',
  adminMerge: 'Merge into…',
  adminMergeHint: 'Type the number of the item that stays — it is at the top of its own page and on every card. Saves, plans, sources, tags and counters all move there. Reversible.',
  adminMergeTargetPh: 'Numeric id of the item that stays',
  adminMergeChecking: 'Looking…',
  adminMergeDirection: 'This one (#{a}) goes into #{b}. #{b} is what stays.',
  adminMergeConfirm: 'Merge into #{id}',
  adminNotePh: 'Note (optional)',
  adminMergeSelf: 'That is this same item',
  adminMergeDone: 'Merged into {id}',
  adminMergedInto: 'Merged into #{id}',
  adminMergeIntoThis: 'Merge into this one',
  adminMergesTitle: 'Merges',
  adminMergeUndone: 'undone',
  adminUnmerge: 'Undo merge',
  adminUnmergeDone: 'Merge undone',
  adminSources: 'Sources that listed it',
  adminSourcesEmpty: 'No source recorded',
  adminSourcePrimary: 'brought it here',
  adminSourceCorroboration: 'listed it too',
  adminSourceAdmin: 'checked by an admin',
  adminSourceAi: 'checked automatically',
  adminSourceAttendee: 'confirmed by someone who went',
  adminDuplicates: 'Possible duplicates',
  adminDuplicatesEmpty: 'Nothing looks like a duplicate',
  adminDupHash: 'Same content',
  adminDupUrl: 'Same link',
  adminDupTitle: 'Same title',
  adminDupWhen: 'Same time and place',
  adminDupSimilar: 'Almost the same title, same hour',
  adminDupPrefix: 'Title starts the same',
  adminDupSource: 'Source page',
  adminDupSameLink: 'Same link for both',
  adminDupInApp: 'Listed here',
  adminDupDifferent: 'What differs',
  adminDupAllSame: 'Every field matches',
  adminDupSame: 'Identical',
  adminDupBothEmpty: 'Empty in both',
  adminDupNot: 'Not the same thing',
  adminDupNotHint: 'They stop being suggested as duplicates of each other. Nothing else changes, and you can undo it.',
  adminDupNotList: 'Ruled out as duplicates',
  adminDupDismissed: 'Ruled out',
  adminDupRestored: 'Suggested again',
  adminKeepThis: 'Keep #{id}',
  adminCombinePick: 'Add to a combine',
  adminCombineAll: 'Pick them all',
  adminCombineNone: 'Pick none',
  adminCombineStart: 'Combine {n} items',
  adminCombineTitle: 'Combine into a new one',
  adminCombineHint: 'One new record out of {ids}. For every field that differs, you pick which one it takes.',
  adminCombineConfirm: 'Create it and merge the rest in',
  adminCombineWarn: '{n} records close and merge into the new one. Every merge can be undone, one at a time.',
  adminCombineDone: 'Combined',
  adminCombineNeedsTwo: 'Combining needs at least two items',
  adminLog: 'Admin log',
  adminLogEmpty: 'Nothing done here yet',
  adminActDelete: 'Deleted',
  adminActWithdraw: 'Withdrawn by its owner',
  adminActRestore: 'Brought back',
  adminActFlag: 'Flagged',
  adminActUnflag: 'Flag cleared',
  adminActMerge: 'Merged',
  adminActUnmerge: 'Merge undone',
  adminRaw: 'Raw data',
  adminRawMetadata: 'What the source gave us',
  adminRawRow: 'The whole row',
  adminEmptyValue: '(empty)',
  versionCompare: 'Compare',
  versionDiffTitle: 'From version {a} to {b}',
  versionDiffNone: 'Nothing changed between these two',

  promoted: 'Ad', free: 'Free',
  whoIsIn: "Who's in? Send to friends ", eventPrefilled:'Event details filled — pick your friends',
  noEvents: 'Nothing with these filters — change the filter',
  loadMore: 'Load more',

  templates: 'Templates', templateApplied: 'Template applied',
  tplHikeLabel: 'Hike', tplHikeTitle: 'Gatineau hike',
  tplCinemaLabel: 'Movie', tplCinemaTitle: "Let's catch a movie",
  tplDinnerLabel: 'Dinner', tplDinnerTitle: 'Dinner out',
  tplCoffeeLabel: 'Coffee', tplCoffeeTitle: 'Coffee & chat',
  tplGameLabel: 'Game', tplGameTitle: 'Board game night at mine',
  plan: 'What do you want to do?', titlePlaceholder: 'e.g. Skating on the Rideau Canal',
  kind: 'Type', category: 'Tag', when: 'When?',
  whenThisWeekend: 'This weekend', whenTonight: 'Tonight', whenFriday: 'Friday',
  whenNextWeek: 'Next week', coordinate: 'By coordination',
  whenFromAvailability: 'My usually-free times',
  detailsOptional: 'Details (optional)', placePlaceholder: 'Where?',
  costPlaceholder: 'Approx cost per person',
  whoToTell: 'Invite friends', fomoNote: " Friends can't see who else was invited or how they answered. Only you can.",
  noFriendsYetCreate: 'No friends yet — add them in the Friends tab, or make the plan and share its link with anyone',
  noFriendsAlertTitle: 'You have no friends yet',
  noFriendsAlertBody: 'A plan goes to your friends, and your list is empty. You can still make it and share its link with anyone — or add friends first.',
  noFriendsAlertContinue: 'Continue anyway',
  noFriendsAlertFriends: 'Go to Friends',
  selectedMark: '✓ selected',
  commonTime: 'Common free time',
  commonTimeDetail: '{day} at {hour}:00 — {count} people free',
  applyIt: 'Use it', commonTimeApplied: '✓ Common time selected',
  aroundTime: '{day} around {hour}:00',
  chainInvite: 'Chain invites',
  moreSignalOptions: 'More options',
  fromEventSummary: 'From the event',
  chainNote: 'Every friend who says "I\'m in" can bring up to a limit you set from their own friends.',
  chainOff: 'Off', chainPlus1: 'Each +1', chainPlus2: 'Each +2', chainUnlimited: 'Unlimited',
  sendInvites: 'Send invites', sendInvitesN: 'Send invites ({n})',
  signalSentToast: 'Invites sent only {count} people you picked were notified',
  writeFirst: "First write what's on your mind ", errorSending:'Error sending', kindDefinite: " I'm going anyway", kindDefiniteSub: "Just letting you know — who's in?",
  kindIfCompany: 'Only if someone joins', kindIfCompanySub: "No company, I'll skip it",
  kindHosting: "I'm hosting", kindHostingSub: 'Party, dinner, hangout at mine',
  kindOpenIdea: 'Just an idea', kindOpenIdeaSub: "Let's see who's interested first",

  imIn: "I'm in", notThisTime: 'Not this time', maybe: 'Maybe',
  conditional: 'Conditional: "I\'m in if..."', imInIf: "I'm in if...",
  changeAnswer: 'Change answer',
  condLater: 'Start later', condDay: 'Another day', condPerson: 'If someone else joins',
  condOwn: 'Or write your own condition:',
  condOwnPlaceholder: "e.g. I'm in if we can carpool",
  respInToast: "We told the host if they're in, the chat opens", respMaybeToast: "You said maybe we'll remind you later",
  respCondToast: 'Your condition was sent',
  respOutToast: "Okay! only the host sees you're out this time", notMyThing: " Not my kind of thing", respNotMyThingToast: "Noted — only the host sees it, and they'll know not to ask again",
  ansNotMyThing: "You said this isn't your kind of thing",
  respNotMyThing: 'Not their thing',
  ansIn: 'You said in', ansMaybe: 'You said maybe',
  ansCondPrefix: 'Condition:', ansOut: 'You said not this time',
  answerPrivateNote: 'Your answer is shown only to the host',

  statusConfirmed: 'Confirmed', statusCompleted: 'Done', statusActive: 'Active',
  inCount: '{n} in', maybeCount: '{n} maybe',
  condCount: '{n} conditional', pendingCount: '{n} no reply',

  shareLink: 'Share link (they can reply without installing)',
  linkToast: 'Link: outami.com/s/{token}',
  answersOnlyYou: 'Answers (only you can see)', guest: 'Guest',
  yourAnswer: 'Your answer',
  noAnswerYet: 'Tap to answer',
  clearAnswer: 'Clear my answer',
  answerCleared: 'Answer cleared',
  answerNow: 'Answer now',
  conditionalHint: 'Say yes, but only if something changes',
  notMyThingHint: "They'll know not to ask you for this kind of thing",
  tabDetails: 'Details', tabChat: 'Chat',
  signalInfo: 'About this plan',
  chatEmpty: 'No messages yet — say hi',
  tapToAnswer: 'Wanna go?',
  signalDetails: 'Details & chat ›',
  respIn: 'In', respOut: 'Out', conditionalShort: 'Conditional',
  confirmPlan: 'Confirm plan',
  confirmPlanHint: 'Confirm that we’re going ahead with this plan.',
  confirmWhenTitle: 'Final time and place',
  confirmNeedsDate: 'Pick a date to confirm',
  confirmNeedsTime: 'Pick a time too',
  confirmNeedsPlace: 'Say where',
  planConfirmedToast: 'Plan confirmed auto-reminder set for everyone',
  planSummary: 'Plan details',
  planRosterTitle: 'Who\'s in',
  planRosterGuests: '+{n} guest(s) without an account',
  planRosterOrganizer: '(organizer)',
  reminderNote: 'Auto-reminder: {h}h before, for everyone',
  logOutcomePrompt: "Once it's over, log the outcome:",
  outcomeDone: 'Done', outcomeDoneShareBtn: 'Done + share plan', outcomeCancel: 'Cancel',
  outcomeDonePrivate: 'Logged kept private',
  outcomeDoneShared: "Logged plan added to others'Discover", outcomeCancelled:'Logged — next time!', doneBadge: 'Done',
  chat: 'Coordination chat',
  chatLockedNote: 'The chat opens once you say "I\'m in"',
  system: 'System', typeMessage: 'Message...',

  // عکس‌های بعد از برنامه (WHOSUP-213) — سربرگِ سوم، بعد از قطعی شدن.
  tabPhotos: 'Photos',
  photosEmpty: 'No photos yet — be the first',
  photosLockedNote: 'Photos open once the plan is confirmed',
  photosMembersNote: 'Photos are just for the people who are in',
  photoAdd: 'Add a photo',
  photoBy: 'by {name}',
  photoCounter: '{i} of {n}',
  photoDownload: 'Download',
  photoDownloadN: 'Download {n}',
  photoSelect: 'Select',
  photoSelectDone: 'Done',
  photoDownloaded: 'Saved',
  photoDownloadFailed: 'Could not save',
  photoDropHint: 'Drop photos here to add them',
  notifSignalPhotosBody: 'Took any photos? Share them with everyone',
  notifChatMessageBody: 'A new message in the chat',
  notifNewPhotoBody: 'A new photo was added',

  userNotFound: 'No user found with that name',
  requestSentToast: "Friend request sent — you'll be friends once they accept ", requestError:'Error (maybe you already asked)',
  groupCreated: 'Group created', incomingRequests: 'Incoming requests',
  friendsCount: 'Friends ({n})',
  noFriendsYet: 'No friends yet — add one below by username or invite link',
  requestSent: 'Pending', myGroups: 'My groups',
  newGroup: '+ New group (e.g. "Hiking crew")', groupNamePlaceholder: 'Group name',
  addFriend: 'Add friend',
  friendNote: 'A friendship by username is two-way: it needs a request and an accept — unlike friends you pick from your contacts above, which are one-way and stay private.',
  friendUsernamePlaceholder: "Your friend's username (e.g. sara)",
  sendFriendRequest: 'Send friend request',
  inviteLink: 'Personal invite link',
  inviteLinkHint: '@{u} — share this so anyone can find you',
  findMeShare: 'Find me on {brand}: @{u}', yourUsernameToast: 'Your username: @{u}',

  tagline: 'Instead of messaging the whole group, tell only the friends who are up for it',
  signIn: 'Sign in / Sign up', email: 'Email', password: 'Password',
  backendNotConfigured: "Demo mode: the backend isn't configured, so sign-in and data won't work yet.",
  accountCreated: 'Account created ✓ now build your profile',
  errorSignIn: 'Sign-in error', oneStepLeft: 'One step left — your profile:',
  displayName: 'Your name (shown to friends)', username: 'Username',
  usernameNote: 'Friends will find you by this username. It starts with an English letter — letters, numbers and _ only.', enterName: 'Enter your name',
  whereYouLiveTitle: 'Where do you live?',
  usernameChecking: 'Checking…',
  usernameRequired: 'Pick a username — it is required',
  usernameUse: 'Use @{u}',
  usernameFree: '@{u} is free',
  usernameTooShort: 'At least 3 characters',

  backAndSave: '‹ Back & save',
  availability: 'Usually-free times',
  availabilityHint: 'Each cell = 1 hour (8am–midnight) · drag to select/clear · "All days" and "Weekend" rows are shortcuts',
  tapDayNameHint: 'tap a day name to select the whole day',
  allDays: 'All days', weekend: 'Weekend',
  availabilitySaved: 'Your usually-free times were saved',
  availabilityExplain: 'When you make a plan with "my usually-free times", the best common time for the group is suggested automatically',
  saveAndBack: 'Save & back',

  settings: 'Settings', notSetYet: 'Not set yet — tap', change: 'Change ›',
  language: 'Language', signOut: 'Sign out',
  menu: 'Menu',
  notOnAppYet: 'Not on {brand} yet',
  notifFriendDeclined: "{name} didn't accept your request",
  gotIt: 'Got it',
  noDetailsYet: 'Nothing else saved about them',
  notifContactJoined: '{name} from your contacts is on Pals & Plans',
  notifTheyFoundYou: '{name} has your number and is on {brand} too',
  notifContactJoinedBody: 'Tap to add them as a friend',
  refreshing: 'Updating…',
  feedback: 'Send feedback',
  feedbackBug: 'Something is broken',
  feedbackIdea: 'I have an idea',
  feedbackOther: 'Something else',
  feedbackPlaceholder: 'What happened? The more detail, the better.',
  feedbackNote: 'Your app version is attached automatically, so we can find it.',
  feedbackDiag: 'Also send a technical report of the app’s last few minutes — screens, buttons and errors, not what you typed.',
  feedbackThanks: 'Thanks — we got it',
  phoneUniqueNote: 'A number belongs to one account. Verifying it here moves it to yours.',
  phoneAlreadyMine: 'That number is already yours',
  phoneVerifyNote: 'We text you a 6-digit code. The number is only added once you enter it.',
  phoneSendCode: 'Send code',
  phoneCodeSent: 'Code sent to {phone}. It expires in 10 minutes.',
  phoneCodeLabel: '6-digit code',
  phoneVerify: 'Verify',
  phoneResend: 'Send again',
  phoneResendIn: 'Send again in {n}s',
  phoneChangeNumber: 'Use a different number',
  phoneCodeWrong: 'Wrong code — {n} tries left',
  phoneCodeExpired: 'That code expired. Ask for a new one.',
  phoneCodeLocked: 'Too many wrong tries. Ask for a new code.',
  phoneCodeNone: 'Ask for a code first',
  phoneCodeTooMany: 'Too many codes for now. Try again in an hour.',
  phoneTakenOver: 'Verified — the number moved to this account ✓',
  phoneSmsUnavailable: 'Text messages are not set up yet, so no number can be added right now.',
  phoneAddLater: 'You can add and verify your phone number later, from your profile.',
  phonesHint:
    'Friends find you by any of these numbers. The default one is shown as yours.',
  phoneDefault: 'Default',
  phoneMakeDefault: 'Make default',
  phoneDefaultSaved: 'Default number updated ✓',
  phoneAdd: 'Add another number',
  phoneRemoveConfirm: 'Remove {phone}? Friends who only have this number will no longer find you.',
  phoneRemoved: 'Number removed',
  contactDuplicatePhone: 'You already have a contact with this number — edit that one instead',
  willGetSms: 'Gets a text',
  noPhoneForContact: 'No phone number for this contact',
  themeToggle: 'Dark theme',
  otherCategory: 'Other',
  audienceAll: 'All my friends',
  audienceAllHint: 'Everyone who is your friend right now — friends you add later need their own invite',
  selectAll: 'Select all',
  unselectAll: 'Clear all',
  contactsCount: '{n} contacts',
  inviteAfterCreateNote: 'The text goes out after you make the plan, so it can carry the link.',
  noOnePickedTitle: 'Nobody picked yet',
  noOnePickedBody: 'You have not chosen who to tell. Send it to all your friends instead?',
  noOnePickedAll: 'Send to all friends',
  noOnePickedBack: 'Let me pick',
  shortIn: 'In',
  shortMaybe: 'Maybe',
  shortConditional: 'If…',
  shortOut: 'Out',
  shortNotMyThing: 'Not for me',
  whenFreeText: 'Write it myself',
  whenFreeTextPlaceholder: 'e.g. Saturday early morning',
  alsoMakeLink: 'Also make a link',
  phoneOnlyCantPick: 'Phone number only — not on the app yet, can\'t be picked here',
  pendingFriendInvitesLeft: "Hasn't accepted your friend request yet — {n} invites left",
  pendingFriendCapFull: "Hasn't accepted your friend request — all {n} invites used",
  inviteCapError: 'Until they accept your friend request, you can send at most {n} invites.',
  alsoMakeLinkHint: 'For anyone not in your friends list',
  publicLinkCopiedNote: "This plan's public link was copied. Send it to anyone — they'll see the plan, but that page takes no answers; they have to tell you directly.",
  shareSignal: 'Share this plan',
  fromYourContacts: 'From your contacts',
  newCategory: '+ New tag',
  newCategoryPlaceholder: 'e.g. Winter hiking',
  pickExact: 'Pick a date & time',
  pickDate: 'Pick a date',
  pickRangeHint: 'Tap a day. Tap a second, later day to make it a range.',
  timeStart: 'Starts',
  timeEnd: 'Ends',
  repeat: 'Repeat',
  pickDayFirst: 'Pick a day first',
  pickTime: 'Time',
  inviteByPhone: 'Invite by text message',
  inviteByPhoneSub: 'People not on {brand} yet — pick them and send a text',
  sendSmsTo: 'Send a text to {n}',
  pickSomeoneFirst: 'Pick at least one person',
  smsUnavailable: 'This phone cannot send text messages',
  signals: 'Plans',
  themeTitle: 'Look & feel',
  themeNight: 'Night',
  themeNightHint: 'Deep navy with amber. Easier on the eyes after dark.',
  themeCoral: 'Day',
  themeCoralHint: 'Powder blue with coral. Clearer in bright light.',
  themeDone: 'Use this one',
  changePhoto: 'Change photo',
  photoSaved: 'Your photo was saved ✓ your friends see it too',
  tapPhotoToChange: 'Tap the photo to change it',
  photoRemoved: 'Photo removed',
  photoPermDenied: 'Photo permission denied — enable it in system settings',
  myProfile: 'My profile',
  cityLabel: 'City', cityPlaceholder: 'e.g. Ottawa',
  searchHint: 'Type to search', searchNoMatch: 'Nothing matched',
  pickCountryFirst: 'Pick a country first',
  usernameLocked: 'Username: @{u} — this one stays, your friends find you by it',
  profileSaved: 'Saved ✓',

  deleteAccount: 'Delete my account',
  deleteAccountSub: 'Close the account and erase what we hold about you',
  deleteAccountWarn: 'There is no undo. Signing in again with the same email starts a new, empty account — nothing comes back.',
  deleteAccountGone: 'Gone for good: your plans, messages, groups, friends, imported contacts, notifications and usually-free times.',
  deleteAccountHashed: 'Scrambled beyond recovery: your name, username, email and phone number.',
  deleteAccountStays: "Messages you wrote inside someone else's thread stay so the conversation still makes sense — but nothing ties them to you any more.",
  deleteAccountReason: 'Why are you leaving?',
  deleteAccountReasonHint: 'Up to you — but it is the only way we learn what to fix.',
  deleteAccountReasonPlaceholder: 'A line or two is plenty',
  deleteAccountConfirmTitle: 'Delete your account?',
  deleteAccountConfirmYes: 'Yes — delete everything',
  deleteAccountKeep: 'No, keep my account',
  deleteAccountWorking: 'Deleting…',
  deleteAccountDone: 'Your account is deleted. Take care.',

  // نسخه‌ی بدونِ ورودِ همین صفحه (WHOSUP-169) — آدرسی که به گوگل‌پلی داده‌ایم.
  deleteAccountSignInFirst: 'To actually delete anything you need to sign in first.',
  deleteAccountSignInCta: 'Sign in and delete my account',
  deleteAccountLockedOut: 'Locked out of your account? Write to {email} and we will delete it for you.',
  deleteAccountReauthTitle: 'One last check: sign in again',
  deleteAccountReauthBody: 'Deleting an account cannot be undone, so we ask you to prove it is you. We sign you out, you sign back in, and you land right back on this page.',
  deleteAccountReauthGo: 'Sign out and sign in again',
  deleteAccountReauthDone: "You're signed in again. The next button deletes your account for good.",

  // حذفِ گزینشیِ داده‌ها، بدونِ بستنِ حساب (WHOSUP-169).
  eraseTitle: 'Delete only some of your data',
  eraseSub: 'Your account stays. Each one goes on its own, straight away.',
  eraseNothing: 'Nothing to delete',
  eraseBtn: 'Delete',
  eraseWorking: 'Deleting…',
  eraseDone: 'Deleted.',
  eraseKeep: 'Keep it',
  eraseConfirmYes: 'Yes — delete it',
  eraseAvatar: 'Profile photo',
  eraseAvatarHas: 'One photo is stored',
  eraseAvatarConfirm: 'Delete your profile photo?',
  erasePhones: 'Phone numbers',
  erasePhonesHas: '{n} phone number(s) saved',
  erasePhonesConfirm: 'Delete every phone number on your account? Friends will no longer find you by number.',
  eraseStatus: 'Status text',
  eraseStatusHas: 'A status text is stored',
  eraseStatusConfirm: 'Delete your status text?',
  eraseContacts: 'Contacts imported from your phone',
  eraseContactsHas: '{n} imported contact(s)',
  eraseContactsConfirm: 'Delete every contact imported from your address book? Friends you added by hand stay.',
  eraseOthersSaw: 'Other people saw these. Anything they already answered or built on stays visible, marked as called off.',
  eraseSignals: 'Plans I made',
  eraseSignalsHas: '{n} plan(s) of yours',
  eraseSignalsConfirm: 'Take down every plan you made? Ones your friends already answered stay visible as cancelled and they get told; the rest simply go.',
  eraseEvents: 'Events I added',
  eraseEventsHas: '{n} event(s) you added',
  eraseEventsConfirm: 'Take down every event you added? Ones someone already built a plan on stay so that plan still makes sense; the rest are deleted.',
  eraseMessages: 'My name on my messages',
  eraseMessagesHas: '{n} message(s) you sent',
  eraseMessagesConfirm: "Take your name off every message you sent? The text stays so other people's conversations still read, but nothing ties it to you.",

  contacts: 'Contacts',
  contactsCardNever: 'Not imported yet — tap to sync',
  contactsCardCount: '{total} contacts · {matched} already on {brand}',
  contactsLastSync: 'Last sync: {when}',
  contactsSyncNow: 'Update contacts',
  contactsSyncing: 'Syncing…',
  contactsSynced: '{imported} contacts saved · {matched} of them on {brand} ✓',
  contactsNoChange: 'Nothing new — your contacts are up to date ✓',
  contactsPermDenied: 'Contacts permission denied — enable it in system settings',
  contactsUnavailable: 'Contacts are not available on this platform (try the app on your phone)',
  contactsError: 'Contact sync failed — try again',
  contactsPrivacyTitle: 'Before we read your contacts',
  contactsPrivacyBody: '{brand} reads your contacts only to tell you which of the people you already know are here. Your contact list stays on your phone — it is never uploaded. Only a scrambled (hashed) form of numbers and emails is sent for the comparison, and it is not stored.',
  contactsPrivacyAgree: 'Got it — read my contacts',
  contactsPrivacyCancel: 'Not now',
  contactsOnwhosup: 'Already on {brand} ({n})',
  contactsNotOnwhosup: 'Not on {brand} yet ({n})',
  contactsEmpty: 'No contacts imported yet',
  contactsFriendOn: '★ Friend',
  contactsFriendOff: '☆ Add as friend',
  contactFriends: 'Friends from your contacts ({n})',
  contactsNotImportedYet: 'No contacts imported yet',
  goToContacts: 'Contacts',
  showAllContacts: 'Show all ({n})',
  showLess: 'Show less',
  remove: 'Remove',
  clear: 'Clear',
  saving: 'Saving…',

  addFriendBtn: 'Add friend',
  addFriendTitle: 'Add friend',
  addFromContacts: 'From my contacts',
  addFromContactsHint: 'Pick someone you already know',
  addManually: 'Enter manually',
  addManuallyHint: 'Type their name and details yourself',
  addByUsername: 'By username',
  addByUsernameHint: 'Send a request to someone already on {brand}',

  allFriendsTab: 'All friends',
  newGroupTab: '＋ New group',
  friendWaitingForYou: 'Waiting for your answer',
  contactsOnwhosupSection: 'From your contacts, already on {brand} ({n})',
  contactsOnwhosupHint: 'People you know who are here but not friends yet',
  sendRequestShort: 'Add',
  // سه فیلدِ ساخت‌یافته‌ی صفحه‌ی جزئیات — نگاه کن به lib/itemFields.ts.
  fieldWhen: 'When', fieldWhere: 'Where', fieldPrice: 'How much',
  altSays: 'Another source says {value}',
  lockedField: 'Locked',
  lockedFields: 'Locked fields',
  lockedFieldsHint: 'The crawler won\'t touch these. Unlock one and its next run writes over it again.',
  unlockField: 'Let the crawler manage it',
  unlockAllFields: 'Unlock everything',
  placeNotFound: 'This one is gone',
  placeAlwaysOpen: 'A place, not a one-off event',
  myGroupsCount: 'My groups ({n})',
  noGroupsYet: 'No groups yet — make one and put your friends in it',
  options: 'Options',
  memberOfGroups: 'In these groups:',
  inNoGroup: 'Not in any group yet',
  addToGroup: "Manage groups",
  removeFromGroup: "remove",
  addToThisGroup: "add",
  addToGroupTitle: 'Groups for {name}',
  editFriend: 'Edit',
  editAppFriendHint: "They're a {brand} user — only they can edit their own profile",
  removeFriend: 'Remove friend',
  removeFriendHint: 'They leave your list and your groups',
  removeFriendConfirm: 'Remove {name} from your friends?',
  friendRemoved: 'Removed',
  addFriendToGroup: 'Add friends',
  groupSettings: 'Group settings',
  addGroup: 'New group',
  addGroupHint: 'Group friends you plan with often',
  editFriendTitle: 'Edit friend',
  groupMembersCount: '{n} in this group',
  groupEmpty: 'Nobody in this group yet — tap a name below to add them',
  inGroup: '✓ In group',
  notInGroup: '＋ Add',
  groupNameLabel: 'Group name',
  groupEmojiLabel: 'Emoji',
  groupTagsHint: 'Type at least 3 letters of the group name to see matching tags',
  createGroup: 'Create group',
  renameGroup: 'Rename',
  deleteGroup: 'Delete group',
  deleteGroupConfirm: 'Delete "{name}"? Your friends are not affected.',
  groupDeleted: 'Group deleted',
  groupRenamed: 'Group updated ✓',
  noFriendsForGroup: 'Add some friends first, then you can group them',
  peopleSection: 'People',
  addSomeone: '＋ Add someone',
  addByPhone: 'By phone',
  addByEmail: 'By email',
  friendPhonePlaceholder: 'Their phone number',
  friendEmailPlaceholder: 'Their email',
  contactNotOnApp: 'Nobody with that number or email is on {brand} yet',
  cantAddYourself: "That's you",
  alreadyFriendsMsg: 'You two are already connected',
  addFriendHowHint: 'Whatever you have — their username, phone, or email',
  switchToContacts: 'Or pick from my contacts',
  switchToManual: 'Or enter manually',
  fieldWhosupUsername: '{brand} username',
  addFoundOnApp: '{name} is already on {brand} — friend request sent ✓',
  friendDetails: 'Their details',
  fieldName: 'Name',
  fieldNamePlaceholder: 'e.g. Sara Ahmadi',
  fieldPhone: 'Phone number',
  fieldPhonePlaceholder: 'e.g. 613 555 0123',
  fieldEmail: 'Email',
  fieldEmailPlaceholder: 'e.g. sara@example.com',
  fieldSocial: 'Social media',
  fieldSocialPlaceholder: 'e.g. instagram.com/sara or @sara',
  nameRequired: 'A name is required',
  addAnother: '+ Add another',
  loadingPhoto: 'Reading their photo…',
  removePhoto: 'Remove photo',
  orPickFromContacts: 'Or pick from your contacts',
  editingContact: 'From contact: {name}',
  noContactsLeft: 'Every contact is already a friend',
  friendAdded: '{name} was added ✓',
  contactsOneWayNote:
    'One-way on purpose: adding someone as a friend needs no request and no approval, and they are not notified. They do not have to be on {brand}.',
  contactsInvite: 'Invite',
  contactsInviteText: "Come to {brand} so we can plan things together — my username is @{u}",
  contactsDeleteAll: 'Delete all contacts from the server',
  contactsDeleted: 'Your contact list was deleted',
  contactsSearch: 'Search contacts',
  never: 'never',
  myPhoneTitle: 'My phone number',
  myPhoneHint:
    'Optional — so friends who already have your number in their phone find you automatically. Without it you can only be found by the email you signed up with.',
  myPhonePlaceholder: 'e.g. 613 555 0123',
  myPhoneSaved: 'Your number was registered ✓',
  myPhoneInvalid: 'That does not look like a phone number',
  save: 'Save',

  linkExpired: "This link expired or doesn't exist",
  guestIn: "I'm in ", guestOut: "Can't make it",
  guestAnswerIn: 'Your answer was sent {name} was notified',
  guestAnswerOut: 'Your answer was saved',

  /* ---------- ورود و ثبت‌نام ---------- */
  /* ---------- مهمان (بدونِ حساب) ---------- */
  guestSignInToUse: 'Sign in to use this',
  guestFriendsTeaser: 'Add friends by username or invite link, and see who is free',

  authSignIn: 'Sign in',
  authSignUp: 'Create account',
  cityRequired: 'Pick where you live — it decides which city’s plans you see.',
  useMyLocation: 'Use my location',
  locating: 'Finding your city…',
  locationOffer: 'Do not want to search? Let {brand} find your city from your location.',
  locationDeniedCity: 'Location is off for {brand}. Turn it on in your settings, or pick your city from the list.',
  locationNoCity: 'We could not match your location to a city on the list. Please pick it yourself.',
  termsAccept: 'I have read and accept the Terms of Use and Privacy Policy',
  termsRead: 'Read',
  termsMustAccept: 'You must accept the terms to create an account',
  termsUpdatedTitle: 'The terms have changed',
  termsUpdatedBody: 'The Terms of Use and Privacy Policy have been updated. Please read the new version and accept it to continue.',
  orContinueWith: 'or continue with',
  authTermsNote: 'By continuing, you accept the {terms}.',
  authTermsLink: 'Terms of Use (EULA)',
  continueApple: 'Continue with Apple',
  continueGoogle: 'Continue with Google',
  continueFacebook: 'Continue with Facebook',
  authProviderOff: 'This sign-in method is not available yet — use your email for now',
  authForgot: 'I forgot my password',
  authWrongCredentials: 'That email and password don’t match. Check the password, or use "I forgot my password".',
  authEmailTaken: 'That email already has an account — switch to Sign in.',
  authNotConfirmed: 'This email is not confirmed yet — check your inbox.',
  authVerifyTitle: 'Check your email',
  authVerifyBody: 'We sent you a link. Open it on this device and {brand} opens signed in. The link works for one hour.',
  authResend: 'Send the email again',
  authBackToSignIn: 'Back to sign in',
  authVerifySent: 'Email sent.',
  authLinkExpired: 'That link expired. Ask for a new one.',
  emailVerified: 'Email confirmed. Welcome!',
  authWeakPassword: 'Password is too short — use at least 6 characters.',
  authBadEmail: 'That doesn\'t look like an email address.',
  authNetwork: 'No connection — check your internet and try again.',
  authNeedEmailFirst: 'Type your email first',
  authResetSent: 'If that email has an account, a reset link is on its way',
  authCodeVerifyBody: 'We emailed you a code. Type it below to confirm your account — it works for one hour.',
  authCodeLabel: 'Code from the email',
  authCodeConfirm: 'Confirm',
  authCodeBad: 'That code is wrong or has expired. Check it, or send the email again.',
  authResetCodeSent: 'If that email has an account, a code is on its way',
  authResetBody: 'Type the code we emailed you and choose a new password.',

  /* ---------- ورود و ثبت‌نام ---------- */
  countryLabel: 'Country', countryPlaceholder: 'e.g. Canada',
  myPhoneSaveFailed: 'Your number could not be saved — you can add it later in Contacts',

  /* ---------- شهر (مایگریشن 0063) ---------- */
  defaultCity: 'Default city',
  defaultCityHint: 'Where your lists start. You can switch city temporarily from the search bar.',
  cityPickerTitle: 'Cities we cover',
  citySearchHint: 'Search a city or country',
  cityBackHome: 'Back to {city}',
  cityRequestCta: 'My city is not here',
  cityRequestSubmit: 'Request this city',
  cityRequestSent: 'Noted — we will start looking for things to do in {city}',
  cityNoContent: 'Nothing in {city} yet',
  pioneerTitle: 'You’re one of the pioneers in {city}!',
  pioneerBody: 'We don’t have events from {city} yet, but we’ve started collecting them and this page will fill up soon. The more friends from {city} who join, the more complete it gets.',
  pioneerInvite: 'Invite your friends',
  pioneerCreate: 'Make a plan',
  pioneerNearby: 'Meanwhile, see events in {city}',

  /* ---------- دعوت با ایمیل (مایگریشن 0066) ---------- */
  inviteMaybe: "Maybe",
  inviteSaved: "Got it — your answer is saved.",
  inviteChange: "Changed your mind? Pick another answer.",
  inviteLocked: "This has already started, so answers are closed.",
  invitePersonal: "This link is yours — anyone who has it can answer as you.",
  addToCalendar: "Add to calendar",
  inviteByEmail: "Invite by email",
  inviteByEmailSub: "People who are not on {brand} — they get an email with their own link",
  inviteEmailPlaceholder: "their@email.com",
  inviteNamePlaceholder: "Name (optional)",
  inviteEmailAdd: "Add",
  inviteEmailSent: "{n} invited by email",
  inviteEmailBad: "That does not look like an email address",
  willGetEmail: "gets an email",
  noWayToReach: "No phone or email for them",

  /* ---------- دعوتِ آدمِ تازه از فرمِ ویرایش (WHOSUP-203) ---------- */
  inviteReachSub: "Anyone not on {brand} yet. Email goes out on its own; for a phone number you send the message yourself.",
  inviteReachPlaceholder: "their@email.com or phone number",
  inviteReachBad: "That is not an email address or a phone number",

  /* ---------- لینکِ عمومیِ خواندنی و دعوت به پیوستن (مایگریشن 0067) ---------- */
  publicPeek: "You are seeing this because someone shared the link.",
  publicNoReply: "To say yes or no, reply to whoever sent you this.",
  joinTitle: "Get your own invites",
  joinBody: "{brand} is how friends sort out who is free and who is coming — without a group chat that nobody reads.",
  joinCta: "Sign in",
  guestAsksUp: "{name} is asking — are you up for it?",
  getItOnPlay: "Get it on Google Play",
  getItOnAppStore: "Download on the App Store",
  scanToInstall: "Scan this with your phone to install the app",
  redirecting: "Taking you to the store…",
  backToSite: "Back to {brand}",
  inviteThanksIn: "You're in 🎉",
  inviteThanksMaybe: "Noted as a maybe.",
  inviteChangeAnswer: "Change my answer",
  inviteJoinTitle: "Want to keep up with this plan?",
  joinWhyUpdates: "Get a heads-up if the time or the place changes",
  joinWhyChat: "Chat with everyone who is coming",
  joinWhyOwn: "And make plans of your own, in seconds",
  joinSmall: "Get {brand}",
  copyInviteLink: "Copy personal link",
  copyInviteLinkHint: "A link just for this person. They can reply from it without an account.",
  copiedToClipboard: "Copied",
  inviteBySms: "Invite by text message",
  contactsBookEmpty: "To invite people from your phone book, {brand} needs access to your contacts. The book stays on your phone — only scrambled numbers are sent, to spot who is already here.",

  /* ---------- گذاشتنِ رمزِ تازه ---------- */
  authSetPassword: "Set a new password",
  authNewPassword: "New password",
  authNewPasswordAgain: "Repeat it",
  authPasswordShort: "Use at least 6 characters",
  authPasswordSimple: "Too simple — mix letters with numbers or symbols",
  authPasswordMismatch: "The two do not match",
  authPasswordChanged: "Done — your password is changed. You are signed in.",
  changePassword: "Change password",
  changePasswordCurrent: "Current password",
  changePasswordNeedCurrent: "Enter your current password first",
  changePasswordSame: "The new password is the same as the current one",
  changePasswordWrongCurrent: "That is not your current password",
  changePasswordDone: "Done — your password is changed.",
  changePasswordNoPassword: "You sign in with Google or Apple, so this account has no password to change.",
  authResetNeedsLink: "Open this page from the link in the reset email. If that link has expired, ask for a new one.",
  authGoSignIn: "Go to sign in",

  // ── ویرایش، لغو و تاریخچه‌ی سیگنال (مایگریشن 0072) ──
  titleLabel: 'Title', placeLabel: 'Place', costLabel: 'Cost', noteLabel: 'Note',
  editSignal: 'Edit',
  editSignalSave: 'Save changes',
  signalSavedToast: 'Saved — everyone invited was told',
  removeSignal: 'Cancel this plan',
  usernameTaken: 'That username is taken — try another',
  accountEmail: 'Account email',
  foundByEmail: 'Friends who have this address in their contacts can find you here',
  foundByEmailMissing: "Not registered yet — friends can't find you by this address",
  removeSignalConfirmCancel: "Someone already said they're in, so it stays visible as cancelled and they get an alarm.",
  removeSignalConfirmDelete: 'Nobody said they were in, so it just disappears.',
  removeSignalConfirmYes: 'Yes, take it back',
  signalCancelledToast: 'Cancelled — everyone who was in has been told',
  signalDeletedToast: 'Deleted',
  signalCancelledBadge: 'Cancelled',
  signalCancelledNote: 'The host cancelled this one.',
  changedSinceYourAnswer: 'This changed after you answered',
  changedSinceYourAnswerHint: 'Have another look, then confirm your answer',
  versionHistory: 'Change history',
  versionNumber: 'Version {n}',
  versionCurrentMark: 'now',
  versionYouAnswered: 'you answered on this one',
  versionsOnlyOne: 'This has never been changed',
  cantRemoveWhoIsIn: "Someone who said they're in can't be taken off the list",
  addMorePeople: 'Invite more people',

  /* مشکل‌های ثبت‌شده روی یه رخداد — فقط برای صاحبِ پروژه (مایگریشن 0082). */
  issueReport: 'Report a problem',
  issueNew: 'New problem…',
  issueNewPh: "What's wrong with this one?",
  issueEmpty: 'Nothing noted yet — write the first one',
  issueSaved: 'Noted',
  issueMissed: 'Missed ..',
  issueWrong: 'Wrong ..',
  issueInappropriate: 'Inappropriate ..',
  issueDuplicate: 'Duplicate ..',
  issueOther: 'Other ..',
  issuePickField: 'Which field?',
  issueWhy: 'Tell us why',
  issueWhyPh: 'Why is this inappropriate?',
  issueOtherPh: 'Describe the problem',
  issueDuplicateTime: 'Same subject, different date or time',
  issueDuplicateComplete: 'Complete duplicate',
  issueBack: 'Back',
  issueFieldTitle: 'Title',
  issueFieldImage: 'Image',
  issueFieldDescription: 'Description',
  issueFieldDescFormat: 'Description format',
  issueFieldTime: 'Time',
  issueFieldAddress: 'Address',
  issueFieldPrice: 'Price',
  issueFieldTicket: 'Buy-ticket button',
  issueFieldTags: 'Tags',
  issueFieldLink: 'Source link',
  issueSavedAsk: 'Noted ✓ — do you know the right one?',
  issueCorrectPh: 'Optional — only if you know it',
  issueAddFix: 'Add it',

  /* اعلانِ مرورگر — نگاه کن به core/lib/webPushOffer.ts */
  pushWebTitle: 'Hear about plans when this tab is closed',
  pushWebWhy: 'Right now you only see a friend\'s plan while {brand} is open in front of you. Let this browser show notifications and it can tell you the moment an invitation arrives — even with the tab closed.',
  pushWebAppBetter: 'The phone app does this better: it keeps working when the browser is shut.',
  pushWebEnable: 'Turn on notifications',
  pushWebLater: 'Later',
  pushWebNo: 'No thanks',
  pushWebBlocked: 'Your browser blocked notifications for this site. Only you can undo that, from the padlock next to the address.',
  pushWebOn: 'Notifications are on in this browser',
  pushWebOff: 'Notifications are off in this browser',
  pushWebTurnOff: 'Turn off',

  // ── متنِ اعلان‌ها ──
  // این‌ها را **دیتابیس** می‌خواند، نه فقط اپ: تریگرهای مایگریشن ۰۱۰۹ سطرِ
  // notifications را از روی همین کلیدها و به زبانِ گیرنده می‌سازند. سطرهای
  // جدولِ notification_strings از همین‌جا تولید می‌شوند — نگاه کن به
  // scripts/gen-notif-strings.mjs و lib/notifStrings.ts.
  notifSignalReceivedBody: 'Coming? One tap answers',
  notifResponseIn: '{name} is in ✋',
  notifResponseOut: "{name} can't make it",
  notifResponseMaybe: '{name} said maybe 🤔',
  notifResponseConditional: '{name} set a condition 🎯',
  notifSomeone: 'Someone',
  notifSignalChangedBody: 'This plan changed',
  notifSignalChangedInBody: "A plan you're in changed — take another look",
  notifSignalCancelledBody: 'This plan was cancelled',
  notifSignalCancelledInBody: "A plan you're in was cancelled",
  notifTagEventBody: 'A new event with a tag you follow',
  chainInviteBtn: 'Bring a friend',
  chainBroughtBy: 'Brought by {name}',
  chainLimitReached: "You've used your invites for this one",
  chainInvitedToast: 'Invited!',
  capacityLabel: 'Max spots (optional)',
  capacityFull: 'This one is full — no spots left',
  capacityOf: '{n} of {max} spots taken',
  deadlineLabel: 'Answer-by deadline (optional)',
  respondBy: 'Answer by {when}',
  deadlinePassed: 'The answer deadline has passed',
  quorumLabel: 'Minimum people (optional)',
  quorumNeed: '{n} more needed for it to happen',
  quorumNeedsTime: 'A minimum-people plan needs a date and time',
  joinGuestBody: "You can reply to the person who invited you directly — or sign up on the web or in the app and answer right there. If you join, you'll also see the chat of who's coming and all the other events around.",
  joinDismiss: "Don't show this again",
  invitedExternal: "Invited from outside — can't answer in the app",
  inviteSent: 'Invite sent',
  inviteFailed: "Invite didn't go through",
  inviteRetry: 'Try again',
  inviteOpened: 'Opened the invite',
  seenNotAnswered: 'Seen — no answer yet',
  notSeenYet: 'Not seen yet',
  linkViews: 'Public link views: {n}',
  myPlans: 'My plans',
  plansCalendar: 'Calendar',
  plansList: 'List',
  plansUpcoming: 'Coming up',
  plansPast: 'Past',
  plansUndated: 'No date yet',
  plansCancelled: 'Cancelled',
  plansEmpty: 'No plans yet — send a signal!',
  planConfirmedMine: 'Confirmed — my plan',
  planConfirmedOther: 'Confirmed — invited',
  planInPending: "I'm in — not confirmed yet",
  planMaybe: 'Maybe / conditional',
  planUnanswered: 'Not answered yet',
  planMineShort: 'My plan',
  planNotFinal: 'not final yet',
  plansBannerText: "Every plan you're part of — confirmed, maybe, or still waiting — on the calendar and in the list, together.",
  friendsBannerText: "Add your friends and put them in groups — “Who's up?” reaches the right people in one tap.",
  discoverBannerText: 'Events and places around your city, in one list — save favourites, follow what interests you, and turn anything into a plan.',
  notifSignalConfirmedBody: "It's on! {when} · {place}",
  notifSignalCompletedBody: 'How did it go? Log the outcome',
  notifSignalReminderBody: 'Coming up: {when} · {place}',
  reminderLabel: 'Reminder',
  reminderNone: 'No reminder',
  reminder30m: '30 min before',
  reminder1h: '1 hour before',
  reminder2h: '2 hours before',
  reminder1d: '1 day before',
  outcomePartial: 'Sort of',
  outcomePartialLogged: 'Logged — half counts too!',
  definiteNeedsTime: 'A definite plan needs a date and time',
  reportAction: 'Report',
  reportUser: 'Report user',
  reportTitle: 'Report a problem',
  reportWhy: "What's wrong?",
  reportReasonSpam: 'Spam or a scam',
  reportReasonHarassment: 'Harassment or bullying',
  reportReasonHate: 'Hate speech',
  reportReasonSexual: 'Sexual or explicit content',
  reportReasonViolence: 'Violence or threats',
  reportReasonFalse: 'False information',
  reportReasonOther: 'Something else',
  filterBlockedTitle: 'Can\'t post this',
  filterBlockedBody: 'It contains words that aren\'t allowed here ({words}). Please rephrase. If you think this is a mistake, you can appeal and we\'ll review it.',
  filterAppeal: 'Appeal',
  filterAppealSent: 'Appeal sent — we\'ll review it within 24 hours',
  heldTitle: 'Not sent',
  heldBody: 'This signal wasn\'t sent to anyone — it contains words that aren\'t allowed ({words}). Only you can see it. Edit the text, or appeal and wait for our review.',
  heldAppealOpen: 'Your appeal is waiting for review. If we approve it, the signal is sent automatically.',
  heldAppealUpheld: 'Your appeal was rejected. The only way to send this signal is to edit its text.',
  heldEdit: 'Edit text',
  notifContentRemovedTitle: 'A moderator hid something you posted',
  modHeldTitle: 'Hidden by a moderator',
  modHeldBody: 'A moderator hid this. Nobody but you can see it now. Reason: {reason}',
  modHeldFix: 'To make it visible again: {fix}',
  modHeldReview: 'I fixed it — review again',
  modHeldAppealOpen: 'Waiting for review. If approved, it becomes visible again automatically.',
  modHeldAppealUpheld: 'Your request was rejected. Fix it as the reason says, then ask again.',
  reportNotePlaceholder: 'Anything else we should know? (optional)',
  reportSubmit: 'Send report',
  reportSentToast: "Thanks — we'll take a look.",
  reportAlready: "You've already reported this.",
  reportPrivateNote: 'Only our team sees this. The person you report is not told.',
  blockAction: 'Block',
  blockUser: 'Block user',
  blockTitle: 'Block {name}?',
  blockWhat: "They won't be able to find you, add you as a friend, or invite you anywhere — and neither will you.",
  blockKeepsShared: 'You won\'t see their plans or chat messages anymore, even in plans you\'re both in. They leave your groups, and you leave theirs.',
  blockNeverTold: "They are never told. To them, you simply aren't there.",
  blockConfirm: 'Block',
  blockedToast: '{name} is blocked.',  blockedUsers: 'Blocked users',
  blockedUsersSub: 'People you have blocked',
  blockedNone: "You haven't blocked anyone.",
  unblockAction: 'Unblock',
  unblockedToast: '{name} is unblocked.',
  // ── تورِ کاربرِ تازه (WHOSUP-83) — ترتیب و منطقِ قدم‌ها در lib/tour.ts ──
  tourDiscoverTitle: 'What is around you',
  tourDiscoverBody: 'Discover lists the events and places in your city. Save what you like, follow the tags you care about, and turn any of them into a plan.',
  tourCreateTitle: "Ask your friends who's up",
  tourCreateBody: 'A plan is one short question — what, when, where. Your friends answer yes, no or maybe, and you watch the answers come in.',
  tourInviteTitle: 'They get it wherever they are',
  tourInviteBody: "Friends already on {brand} get a notification. Have only their email? An invite email goes out. Only their phone? The text message is written for you — you just press send. And every plan has a link you can share anywhere.",
  tourNotifTitle: 'Answers come back to you',
  tourNotifBody: 'Notifications tell you when someone answers, when a plan is confirmed, and when something you follow shows up. Settings decides what reaches you.',
  tourSkip: 'Skip',
  tourNext: 'Next',
  tourFinish: 'Got it',
  tourProgress: '{n} of {total}',
  tourAgain: 'Quick tour',
  tourAgainHint: 'The four-step intro, again',
  // WHOSUP-308: برگه و نوارِ پیشنهادِ ثبت‌نام به مهمان.
  browseFirst: 'Just browse for now',
  gatePlan: 'Sign up to make a plan and see which friends are in.',
  gateSave: 'Sign up to save this and find it again on any device.',
  gateRespond: 'Sign up to answer, and hear about it if anything changes.',
  gateFriends: 'Sign up to see your friends and what they are up to.',
  panelPlan1: 'Pick a time and place — your friends answer in one tap.',
  panelPlan2: 'See at a glance who is in, who is a maybe, and who can’t make it.',
  panelPlan3: 'Chat with everyone who is coming, all in one place.',
  panelFriends1: 'Find your friends from your contacts in seconds.',
  panelFriends2: 'See what they are up to this week and jump in.',
  panelFriends3: 'Make groups, so inviting the usual crew takes one tap.',
  gateNotifs: 'Sign up to get notified about plans and invites.',
  gateProfile: 'Sign up for a profile, your free times and your settings.',
  gateFollow: 'Sign up to follow this and hear about new events.',
  gateSuggest: 'Sign up to suggest a new place or event for everyone to discover.',
  nudgeBody: 'Like what you see? With an account you can go with friends.',
  later: 'Later',
};

export default dict;
